import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import { db } from "../firebaseConfig";
import { collection, getDocs, doc, setDoc } from "firebase/firestore";

const CreateCollection = () => {
  const [documents, setDocuments] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [formFields, setFormFields] = useState({});
  const [newDocId, setNewDocId] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "document_types"));
        const docs = querySnapshot.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
        setDocuments(docs);
      } catch (err) {
        setError("Dokümanlar getirilirken hata oluştu: " + err.message);
      } finally {
        setFetching(false);
      }
    };
    fetchDocuments();
  }, []);

  const handleSelectDoc = (docId) => {
    const d = documents.find((d) => d.id === docId);
    setSelectedDoc(d);
    const { id, ...fields } = d;
    setFormFields(fields);
    setSuccess(false);
    setError("");
  };

  const handleFieldChange = (key, value) => {
    setFormFields((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = async () => {
    if (!newDocId.trim()) {
      setError("Lütfen yeni doküman ID'si girin.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await setDoc(doc(db, "document_types", newDocId), {
        ...formFields,
      });
      setSuccess(true);
      setNewDocId("");
    } catch (err) {
      console.error(err);
      setError("Kayıt sırasında hata oluştu: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const renderField = (key, value) => {
    if (typeof value === "boolean") {
      return (
        <FormControl fullWidth key={key} sx={{ mb: 2 }}>
          <InputLabel>{key}</InputLabel>
          <Select
            value={String(value)}
            label={key}
            onChange={(e) => handleFieldChange(key, e.target.value === "true")}
          >
            <MenuItem value="true">true</MenuItem>
            <MenuItem value="false">false</MenuItem>
          </Select>
        </FormControl>
      );
    }

    if (Array.isArray(value)) {
      return (
        <TextField
          key={key}
          label={key}
          fullWidth
          multiline
          rows={4}
          value={JSON.stringify(value, null, 2)}
          onChange={(e) => {
            try {
              handleFieldChange(key, JSON.parse(e.target.value));
            } catch {}
          }}
          sx={{ mb: 2 }}
        />
      );
    }

    return (
      <TextField
        key={key}
        label={key}
        fullWidth
        value={value ?? ""}
        onChange={(e) => handleFieldChange(key, e.target.value)}
        sx={{ mb: 2 }}
      />
    );
  };

  return (
    <Box sx={{ width: "100%", maxWidth: 700, mx: "auto", p: 3 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold", color: "#582b70" }}>
        Koleksiyon Oluştur
      </Typography>

      {fetching ? (
        <CircularProgress sx={{ color: "#582b70" }} />
      ) : (
        <>
          <FormControl fullWidth sx={{ mb: 4 }}>
            <InputLabel>Şablon Doküman Seç</InputLabel>
            <Select
              value={selectedDoc?.id ?? ""}
              label="Şablon Doküman Seç"
              onChange={(e) => handleSelectDoc(e.target.value)}
            >
              {documents.map((d) => (
                <MenuItem key={d.id} value={d.id}>
                  {d.id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {selectedDoc && (
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: "bold" }}>
                Alanları Düzenle
              </Typography>

              {Object.entries(formFields).map(([key, value]) =>
                renderField(key, value)
              )}

              <TextField
                label="Yeni Doküman ID (ör: tozos-2025-2026-tf-basari)"
                fullWidth
                value={newDocId}
                onChange={(e) => setNewDocId(e.target.value)}
                sx={{ mb: 2, mt: 1 }}
              />

              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
              {success && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  Doküman başarıyla oluşturuldu!
                </Alert>
              )}

              <Button
                variant="contained"
                fullWidth
                onClick={handleSave}
                disabled={loading}
                sx={{
                  backgroundColor: "#582b70",
                  "&:hover": { backgroundColor: "#4a245f" },
                }}
              >
                {loading ? (
                  <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                  "Kaydet"
                )}
              </Button>
            </Paper>
          )}
        </>
      )}
    </Box>
  );
};

export default CreateCollection;